module.exports = __webpack_public_path__ + "img/avatar0.0c0b6337.png";